import {Component, Input, Output, EventEmitter} from '@angular/core';
import { CustomSequenceLightFormInterface } from '@app/app/dashboard/forms/park-custom-sequence-light-form/park-custom-sequence-light-form.component';

export interface UpdatedSequenceBlockInterface {
  block: number;
  value: boolean | number;
}

@Component({
  templateUrl: './custom-sequence-feature-control.html',
  selector: 'custom-sequence-feature-control',
  styles: [`
    .btn-custom-feature .btn-list {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 3px;
    }
  `],
})

export class CustomSequenceFeatureControlComponent {
  @Input() value: boolean | number;
  @Input() isLed: boolean;
  @Input() public block: number;

  @Output() updateSequenceBlock = new EventEmitter<UpdatedSequenceBlockInterface>();

  inProgress = false;

  constructor() {
  }

  public changeLight({ value }: CustomSequenceLightFormInterface) {
    setTimeout(() => {
      this.updateSequenceBlock.emit({block: this.block, value});
    }, 0);
  }

  public changeFeature() {
    this.inProgress = true;

    setTimeout(() => {
      this.updateSequenceBlock.emit({block: this.block, value: !this.value});
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/custom-sequences/feature-control/custom-sequence-feature-control.component.ts